import { render, staticRenderFns } from "./account.vue?vue&type=template&id=42de2a5d&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
import style0 from "./account.vue?vue&type=style&index=0&id=42de2a5d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42de2a5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42de2a5d')) {
      api.createRecord('42de2a5d', component.options)
    } else {
      api.reload('42de2a5d', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=42de2a5d&scoped=true", function () {
      api.rerender('42de2a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/account.vue"
export default component.exports